/** Shared Yes/No copy for boolean fields. Filter/sort values stay `true`/`false`. */

export const BOOLEAN_YES_NO_OPTIONS = [
  { text: 'Yes', value: 'true' },
  { text: 'No', value: 'false' },
];

export function isTruthyBooleanFlag(value) {
  const normalized = String(value ?? '')
    .trim()
    .toLowerCase();
  return value === true || normalized === 'true' || normalized === '1';
}

export function formatBooleanYesNo(value) {
  return isTruthyBooleanFlag(value) ? 'Yes' : 'No';
}

/** Properties: student housing flag shown as Property Type labels. */
export function formatStudentHousingPropertyType(value) {
  return isTruthyBooleanFlag(value) ? 'student' : 'conventional';
}

/** Chip labels when the stored filter value is already `'true'` / `'false'`. */
export function formatBooleanFlagChipLabel(value) {
  if (value === 'true') return 'Yes';
  if (value === 'false') return 'No';
  return String(value ?? '');
}

export function formatOptionalBooleanYesNo(value, emptyLabel = 'No Data') {
  if (value == null || String(value).trim() === '') return emptyLabel;
  return formatBooleanYesNo(value);
}
